import { render, staticRenderFns } from "./SubscriptionPlan.vue?vue&type=template&id=969460ae&scoped=true&"
import script from "./SubscriptionPlan.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPlan.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPlan.vue?vue&type=style&index=0&id=969460ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969460ae",
  null
  
)

export default component.exports